import { Component, output, TemplateRef, input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-info-group',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './info-group.component.html',
  styleUrl: './info-group.component.scss',
})
export class InfoGroupComponent {
  readonly firstValue = input<string | undefined>('-');
  readonly secondValue = input<string | undefined>('-');
  readonly tooltipTemplate = input<TemplateRef<any>>();
  viewDetails = output<void>();
}
